<template>
    <div class="container">
        <homeHead ref="homeHead" />
        <div class="er-page">
            <!--标签页：概况/工作室查询/工作室成果/工作室资讯-->
            <div class="tab-row">
                <studio-menu :item-num="this.activeItem"
                             studio-nature="3"
                             @change-item="changeItem"/>
            </div>
            <div class="module-content">
                <!--概况-->
                <studio-overview v-if="activeItem==='1'"
                                 studio-nature="3"
                                 @change-parent-item="changeParentItem"/>
                <!--工作室查询-->
                <studio-query v-if="activeItem==='2'"
                              studio-nature="3"/>
                <!--工作室成果-->
                <studio-achievement v-if="activeItem==='3'"
                                    studio-nature="3"
                                    :achieve-mode="this.achieveMode"
                                    @change-mode="changeMode"/>
                <!--工作室资讯-->
                <studio-news v-if="activeItem==='4'"
                             studio-nature="3"
                             :news-mode="this.newsMode"
                             @change-mode="changeMode"/>
            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import homeHead from "@/components/homeHead.vue";
import studioOverview from "@/components/studio/studioOverview.vue";
import studioQuery from "@/components/studio/studioQuery";
import studioAchievement from "@/components/studio/studioAchievement";
import homeFooter from "@/components/homeFooter";
import studioMenu from "@/components/studio/studioMenu.vue";
import studioNews from "@/components/studio/studioNews.vue";

export default {
    components: {studioNews, studioMenu, homeHead,studioOverview,studioQuery,studioAchievement,homeFooter},
    name: "studioHome",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "rectorStudioHome",
            activeItem:"1",
            achieveMode:'page',
            newsMode:'page',
        }
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.activePath = this.$store.state.params.jumpParams.activePath;
        this.activeItem = this.$store.state.params.jumpParams.activeItem;
        this.$refs.homeHead.activePath = this.activePath;
    },
    methods: {
        changeItem(item){
            this.$store.commit("params/setJumpParams", {});
            this.activeItem = item;
            if (item==='3'){
                this.achieveMode = this.pageMode;
            }
            if (item==='4'){
                this.newsMode = this.pageMode;
            }
        },
        changeParentItem(activeItem){
            this.activeItem = activeItem;
        },
        changeMode(item,i){
            if (i==='3'){
                this.achieveMode = item;
            }
            if (i==='4'){
                this.newsMode = item;
            }
        },
    }
}
</script>
<!--内联样式-->
<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100vh;
    margin: 0;
    overflow-y: auto;
    overflow-x: hidden;
}
.er-page {
    min-height: 100vh;
    box-sizing: border-box;
    padding: 100px 40px 20px;
    background: url("../../assets/screen/homeBg.png") no-repeat center center;
    background-size: cover;
}
/*标签页*/
.tab-row {
    display: flex;
    align-items: center;
    gap: 16px;
    max-width: 1840px;
    margin: 0 auto 24px;
}
.module-content {
    max-width: 1840px;
    margin: 0 auto;
    min-height: calc(100vh - 182px);
    box-sizing: border-box;
}
</style>
